/**
 * IMPORTS
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

import { handleAtualizarTarefa } from "@/domain/use-cases/my-tasks/atualizar-tarefa";
// utils
import { notifyAlert, notifyError, notifySuccess } from "@/utils/notify-messages";

// typings
import { IUpdateTarefaPayload } from "./interface";

/**
 * Hook: useUpdateTarefa
 */
function useUpdateTarefa() {
  // responsável por invalidar as queries
  const queryClient = useQueryClient();

  // token de acesso
  const { token: accessToken } = useStoreZustandUserAuth();

  // mutation para atualizar a tarefa
  return useMutation({
    mutationFn: async ({ id_remessa, payload }: IUpdateTarefaPayload) => {
      return await handleAtualizarTarefa(accessToken!, id_remessa, payload!);
    },
    onSuccess: async (responseTarefaAtualizada, variables) => {
      if (responseTarefaAtualizada?.message === "Remessa não encontrada.") {
        notifyAlert(responseTarefaAtualizada?.message);
        return;
      }

      if (variables.ui?.invalidateRecepcao) {
        await queryClient.invalidateQueries({
          queryKey: ["recepcao"],
          exact: false,
        });
      } else {
        await queryClient.invalidateQueries({
          queryKey: ["minhas-tarefas-admin"],
          exact: true,
        });

        await queryClient.invalidateQueries({
          queryKey: ["expedicoes"],
        });
      }

      const defaultExpedicaoMsg = "Tarefa atribuída com sucesso!";
      notifySuccess(
        variables.ui?.successMessage ?? responseTarefaAtualizada?.message ?? defaultExpedicaoMsg
      );
    },
    onError: (_error, variables) => {
      notifyError(variables.ui?.errorMessage ?? "Erro ao atualizar tarefa!");
    },
  });
}

/**
 * EXPORTS
 */
export { useUpdateTarefa };
